// Generated by purs version 0.14.4
import * as Control_Applicative from "../Control.Applicative/index.js";
import * as Control_Bind from "../Control.Bind/index.js";
import * as Data_Either from "../Data.Either/index.js";
import * as Data_Eq from "../Data.Eq/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_Record from "../Data.Record/index.js";
import * as Data_Show from "../Data.Show/index.js";
import * as Data_Symbol from "../Data.Symbol/index.js";
import * as Effect_Aff from "../Effect.Aff/index.js";
import * as Effect_Class from "../Effect.Class/index.js";
import * as Effect_Console from "../Effect.Console/index.js";
import * as Foreign_Generic_Class from "../Foreign.Generic.Class/index.js";
import * as Global_Unsafe from "../Global.Unsafe/index.js";
import * as Restaumatic_Services_Storage from "../Restaumatic.Services.Storage/index.js";
import * as Restaumatic_TypesGen from "../Restaumatic.TypesGen/index.js";
var cachedGeocoding = function (v) {
    return function (next) {
        return {
            geocodeAddress: function (country) {
                return function (address) {
                    return Control_Bind.bind(Effect_Aff.bindAff)(Effect_Class.liftEffect(Effect_Aff.monadEffectAff)(Restaumatic_Services_Storage.getJSONItem(Foreign_Generic_Class.recordDecode()(Foreign_Generic_Class.decodeRecordCons()(Foreign_Generic_Class.decodeRecordCons()(Foreign_Generic_Class.decodeRecordCons()(Foreign_Generic_Class.decodeRecordNil)({
                        reflectSymbol: function () {
                            return "results";
                        }
                    })(Foreign_Generic_Class.decodeWithOptionsRecord()(Foreign_Generic_Class.decodeRecordCons()(Foreign_Generic_Class.decodeRecordNil)({
                        reflectSymbol: function () {
                            return "location";
                        }
                    })(Foreign_Generic_Class.decodeWithOptionsOther(Foreign_Generic_Class.maybeDecode(Foreign_Generic_Class.recordDecode()(Foreign_Generic_Class.decodeRecordCons()(Foreign_Generic_Class.decodeRecordCons()(Foreign_Generic_Class.decodeRecordNil)({
                        reflectSymbol: function () {
                            return "longitude";
                        }
                    })(Foreign_Generic_Class.decodeWithOptionsOther(Foreign_Generic_Class.numberDecode))())({
                        reflectSymbol: function () {
                            return "latitude";
                        }
                    })(Foreign_Generic_Class.decodeWithOptionsOther(Foreign_Generic_Class.numberDecode))()))))()))())({
                        reflectSymbol: function () {
                            return "country";
                        }
                    })(Foreign_Generic_Class.decodeWithOptionsOther(Restaumatic_TypesGen.decodeCountry))())({
                        reflectSymbol: function () {
                            return "address";
                        }
                    })(Foreign_Generic_Class.decodeWithOptionsRecord()(Foreign_Generic_Class.decodeRecordCons()(Foreign_Generic_Class.decodeRecordCons()(Foreign_Generic_Class.decodeRecordCons()(Foreign_Generic_Class.decodeRecordNil)({
                        reflectSymbol: function () {
                            return "streetNumber";
                        }
                    })(Foreign_Generic_Class.decodeWithOptionsOther(Foreign_Generic_Class.stringDecode))())({
                        reflectSymbol: function () {
                            return "street";
                        }
                    })(Foreign_Generic_Class.decodeWithOptionsOther(Foreign_Generic_Class.stringDecode))())({
                        reflectSymbol: function () {
                            return "city";
                        }
                    })(Foreign_Generic_Class.decodeWithOptionsOther(Foreign_Generic_Class.stringDecode))()))()))(v.storage)(v.key)))(function (v1) {
                        if (v1 instanceof Data_Maybe.Just && (Data_Eq.eq(Data_Eq.eqRec()(Data_Eq.eqRowCons(Data_Eq.eqRowCons(Data_Eq.eqRowCons(Data_Eq.eqRowNil)()({
                            reflectSymbol: function () {
                                return "streetNumber";
                            }
                        })(Data_Eq.eqString))()({
                            reflectSymbol: function () {
                                return "street";
                            }
                        })(Data_Eq.eqString))()({
                            reflectSymbol: function () {
                                return "city";
                            }
                        })(Data_Eq.eqString)))(Data_Record.getField(Data_Record.hasFieldRecord({
                            reflectSymbol: function () {
                                return "address";
                            }
                        })())(Data_Symbol.SProxy.value)(v1.value0))(address) && Data_Eq.eq(Restaumatic_TypesGen.eqCountry)(Data_Record.getField(Data_Record.hasFieldRecord({
                            reflectSymbol: function () {
                                return "country";
                            }
                        })())(Data_Symbol.SProxy.value)(v1.value0))(country))) {
                            return Control_Bind.discard(Control_Bind.discardUnit)(Effect_Aff.bindAff)(Effect_Class.liftEffect(Effect_Aff.monadEffectAff)(Effect_Console.log("Geocoding: Using cached result for " + (Data_Show.show(Restaumatic_TypesGen.showCountry)(country) + (" " + Global_Unsafe.unsafeStringify(address))))))(function () {
                                return Control_Applicative.pure(Effect_Aff.applicativeAff)(new Data_Either.Right(Data_Record.getField(Data_Record.hasFieldRecord({
                                    reflectSymbol: function () {
                                        return "results";
                                    }
                                })())(Data_Symbol.SProxy.value)(v1.value0)));
                            });
                        };
                        return Control_Bind.discard(Control_Bind.discardUnit)(Effect_Aff.bindAff)(Effect_Class.liftEffect(Effect_Aff.monadEffectAff)(Effect_Console.log("Geocoding: Cached result not found for " + (Data_Show.show(Restaumatic_TypesGen.showCountry)(country) + (" " + Global_Unsafe.unsafeStringify(address))))))(function () {
                            return Control_Bind.bind(Effect_Aff.bindAff)(Data_Record.getField(Data_Record.hasFieldRecord({
                                reflectSymbol: function () {
                                    return "geocodeAddress";
                                }
                            })())(Data_Symbol.SProxy.value)(next)(country)(address))(function (response) {
                                if (response instanceof Data_Either.Right) {
                                    return Control_Bind.discard(Control_Bind.discardUnit)(Effect_Aff.bindAff)(Effect_Class.liftEffect(Effect_Aff.monadEffectAff)(Restaumatic_Services_Storage.setJSONItem(Foreign_Generic_Class.recordEncode()(Foreign_Generic_Class.encodeRecordCons()(Foreign_Generic_Class.encodeRecordCons()(Foreign_Generic_Class.encodeRecordCons()(Foreign_Generic_Class.encodeRecordNil)({
                                        reflectSymbol: function () {
                                            return "results";
                                        }
                                    })(Foreign_Generic_Class.encodeWithOptionsRecord()(Foreign_Generic_Class.encodeRecordCons()(Foreign_Generic_Class.encodeRecordNil)({
                                        reflectSymbol: function () {
                                            return "location";
                                        }
                                    })(Foreign_Generic_Class.encodeWithOptionsOther(Foreign_Generic_Class.maybeEncode(Foreign_Generic_Class.recordEncode()(Foreign_Generic_Class.encodeRecordCons()(Foreign_Generic_Class.encodeRecordCons()(Foreign_Generic_Class.encodeRecordNil)({
                                        reflectSymbol: function () {
                                            return "longitude";
                                        }
                                    })(Foreign_Generic_Class.encodeWithOptionsOther(Foreign_Generic_Class.numberEncode)))({
                                        reflectSymbol: function () {
                                            return "latitude";
                                        }
                                    })(Foreign_Generic_Class.encodeWithOptionsOther(Foreign_Generic_Class.numberEncode)))))))))({
                                        reflectSymbol: function () {
                                            return "country";
                                        }
                                    })(Foreign_Generic_Class.encodeWithOptionsOther(Restaumatic_TypesGen.encodeCountry)))({
                                        reflectSymbol: function () {
                                            return "address";
                                        }
                                    })(Foreign_Generic_Class.encodeWithOptionsRecord()(Foreign_Generic_Class.encodeRecordCons()(Foreign_Generic_Class.encodeRecordCons()(Foreign_Generic_Class.encodeRecordCons()(Foreign_Generic_Class.encodeRecordNil)({
                                        reflectSymbol: function () {
                                            return "streetNumber";
                                        }
                                    })(Foreign_Generic_Class.encodeWithOptionsOther(Foreign_Generic_Class.stringEncode)))({
                                        reflectSymbol: function () {
                                            return "street";
                                        }
                                    })(Foreign_Generic_Class.encodeWithOptionsOther(Foreign_Generic_Class.stringEncode)))({
                                        reflectSymbol: function () {
                                            return "city";
                                        }
                                    })(Foreign_Generic_Class.encodeWithOptionsOther(Foreign_Generic_Class.stringEncode))))))(v.storage)(v.key)({
                                        address: address,
                                        country: country,
                                        results: response.value0
                                    })))(function () {
                                        return Control_Applicative.pure(Effect_Aff.applicativeAff)(new Data_Either.Right(response.value0));
                                    });
                                };
                                return Control_Applicative.pure(Effect_Aff.applicativeAff)(response);
                            });
                        });
                    });
                };
            }
        };
    };
};
export {
    cachedGeocoding
};
//# sourceMappingURL=index.js.map
